import Image from 'next/image';
import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { styled } from 'styled-components';

const MARKDOWN = dynamic(() => import('../../utils/react-markdown'));

const StyledMarkdownContainer = styled.div`
  line-height: 1.8rem;
  color: #677083;

  font-size: 14px;
  font-weight: 400;
  line-height: 28px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 28px;
  }

  /* Paragraph styling with line breaks */
  p {
    color: #677083;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 12px;
    white-space: pre-line;

    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 28px;
    }
  }
`;

interface TourDetailedInfoProps {
  title: string;
  content: string;
}

const TourDetailedInfo: React.FC<TourDetailedInfoProps> = ({
  title,
  content
}) => {
  const initialChars = 400;
  const [expanded, setExpanded] = useState(false);

  const shouldTruncate = content.length > initialChars;
  const displayContent =
    expanded || !shouldTruncate
      ? content
      : content.slice(0, initialChars) + '...';

  // Add line breaks after each p tag
  return (
    <div className="my-8">
      <h2 className="text-[22px] md:text-[24px] lg:text-[26px] font-bold mb-4">
        {title}
      </h2>
      <StyledMarkdownContainer>
        <MARKDOWN content={displayContent} />
        {shouldTruncate && (
          <div>
            <button
              className="mt-1 flex items-center gap-1 text-primary font-semibold underline cursor-pointer"
              onClick={() => setExpanded(e => !e)}
            >
              {expanded ? 'Read less' : 'Read more'}
              <span>
                {expanded ? (
                  <Image
                    src="/left_arrow_blue.svg"
                    width={16}
                    height={16}
                    priority={true}
                    alt="left-arrow"
                  />
                ) : (
                  <Image
                    src="/right_arrow_blue.svg"
                    width={16}
                    height={16}
                    priority={true}
                    alt="right-arrow"
                  />
                )}
              </span>
            </button>
          </div>
        )}
      </StyledMarkdownContainer>
    </div>
  );
};

export default TourDetailedInfo;
